import React, { memo } from 'react';
import './ProjectStatusCell.css';

const ProjectStatusCell = memo(({ status, dueDate, lastStageChangeDate }) => {
  // Parse the status to get emoji and text
  const getStatusDisplay = () => {
    if (!status) {
      return { emoji: '⚪', text: 'Unknown', className: 'status-unknown' };
    }
    
    switch (status) {
      case '🟢 On Track':
        return { emoji: '🟢', text: 'On Track', className: 'status-on-track' };
      case '🔴 Overdue':
        return { emoji: '🔴', text: 'Overdue', className: 'status-overdue' };
      case '✅ Completed':
        return { emoji: '✅', text: 'Completed', className: 'status-completed' };
      case '⏸️ On Hold':
        return { emoji: '⏸️', text: 'On Hold', className: 'status-on-hold' };
      default:
        // Handle cases where status might not have emoji prefix
        if (status.includes('On Track')) {
          return { emoji: '🟢', text: 'On Track', className: 'status-on-track' };
        } else if (status.includes('Overdue')) {
          return { emoji: '🔴', text: 'Overdue', className: 'status-overdue' };
        } else if (status.includes('Completed')) {
          return { emoji: '✅', text: 'Completed', className: 'status-completed' };
        } else if (status.includes('Hold')) {
          return { emoji: '⏸️', text: 'On Hold', className: 'status-on-hold' };
        }
        return { emoji: '⚪', text: status, className: 'status-unknown' };
    }
  };

  const calculateDaysInfo = () => {
    if (!lastStageChangeDate) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const stageChangeDate = new Date(lastStageChangeDate);
    stageChangeDate.setHours(0, 0, 0, 0);

    const diffTime = today - stageChangeDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return 'Changed today';
    } else if (diffDays === 1) {
      return '1 day in stage';
    } else {
      return `${diffDays} days in stage`;
    }
  };

  const formatTooltip = () => {
    const lines = [];
    const statusDisplay = getStatusDisplay();

    lines.push(`Status: ${statusDisplay.text}`);

    if (lastStageChangeDate) {
      const changedDate = new Date(lastStageChangeDate).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
      lines.push(`Stage changed: ${changedDate}`);

      const daysInfo = calculateDaysInfo();
      if (daysInfo) {
        lines.push(daysInfo);
      }
    }

    return lines.join('\n');
  };

  const statusDisplay = getStatusDisplay();

  return (
    <div
      className={`project-status-cell ${statusDisplay.className}`}
      title={formatTooltip()}
    >
      <span className="status-emoji">{statusDisplay.emoji}</span>
      <span className="status-text">{statusDisplay.text}</span>
    </div>
  );
});

ProjectStatusCell.displayName = 'ProjectStatusCell';

export default ProjectStatusCell;